import { projectApiUrl } from "API/urls/project.api";
import { axiosInstance } from "configs/axios";

export const getProjectByIdApi = async (projectId) => {
  try {
    const response = await axiosInstance.get(
      projectApiUrl.getProjects + "/" + projectId
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
